module.exports = __webpack_public_path__ + "static/media/celemi-board-image.02775853.svg";